import styled from "styled-components";
export const Label = styled.label `
    font-size: 18px;
    font-weight: 500;
    word-break: break-word;
    margin-left: 2px;
    margin-bottom: 2px;
    display: inline-block;
`;
